/**
 * Разбор query-параметров, совместимых со старым OrganicWebQuiz.
 * Приоритет варианта: `onboardingVariant` (как в WebQuiz) → env → 'default'.
 * Тот же порядок обязан соблюдать inline-preload в index.html.
 */
export const SUPPORTED_PRODUCT = 'fit';

export interface ResolvedQuery {
  variant: string;
  variantSource: 'onboardingVariant' | 'env' | 'default' | 'amplitude' | 'firebase';
  /** Значение `debug_product_name` (legacy WebQuiz), если передано. */
  requestedProduct?: string;
  /** true, если запрошен продукт, отличный от поддерживаемого — рантайм должен предупредить. */
  unsupportedProduct: boolean;
  debug: boolean;
  /** `preview=1`: open any screen or page without funnel progress. Never on production. */
  preview: boolean;
  /** Preview only: onboarding generated by KA; the paywall pays as its user (WebPaywalls parity). */
  previewOnboardingId?: string;
}

const flag = (value: string | null): boolean => value === '1' || value === 'true';

// Mongo ObjectId: the only shape the gateway hands out.
const OBJECT_ID = /^[a-f0-9]{24}$/i;

export const resolveQuery = (
  params: URLSearchParams,
  envVariant?: string,
  options: { production?: boolean } = {},
): ResolvedQuery => {
  const fromQuery = params.get('onboardingVariant')?.trim();
  const fromEnv = envVariant?.trim();
  const [variant, variantSource]: [string, ResolvedQuery['variantSource']] = fromQuery
    ? [fromQuery, 'onboardingVariant']
    : fromEnv
      ? [fromEnv, 'env']
      : ['default', 'default'];
  const requestedProduct = params.get('debug_product_name')?.trim() || undefined;
  const debugValue = params.get('debug');
  const preview = !options.production && flag(params.get('preview'));
  const onboardingId = params.get('onboardingId')?.trim();
  return {
    variant,
    variantSource,
    requestedProduct,
    unsupportedProduct: Boolean(requestedProduct && requestedProduct !== SUPPORTED_PRODUCT),
    debug: flag(debugValue),
    preview,
    previewOnboardingId: preview && onboardingId && OBJECT_ID.test(onboardingId) ? onboardingId : undefined,
  };
};
